module.exports = __webpack_public_path__ + "media/favicon/favicon-36d78850.ico";